import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV160({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.6.0" date="29th August 2025" title="You'll love this addition!">
      <p className="text-gray-300 mb-4">We all love a little break during a game, everyone pops off to do their own thing during a break. Now when an admin user restated the game they get the option to "Notify all players that the game has restarted!". Everyone that has Poppy Poker installed then receives an audio notification informing them the game has restarted! A cool feature that nobody else has mastered yet!</p>
      <p className="text-gray-300 mb-4">Here's a list of new features you may like:</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Added game restart audio broadcast when game resumes after breaks', '/v1.6.0/restartNotificaton.jpg')}
        {createClickableListItem('Added a version check popup', '/v1.6.0/appUpgrade.png')}
        <li>• Removed unwanted components</li>
        <li>• Changed email provider for faster email delivery!</li>
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.6.0/appUpgrade.png', 'Version check popup feature preview')}
          {createThumbnail('/v1.6.0/restartNotificaton.jpg', 'Game restart audio broadcast when game resumes after breaks feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">Try out these new features and let us know what you think (by using the new feedback feature 😜)</p>
    </ReleaseCard>
  );
}
